import React, { Fragment } from 'react';
import { Intro, Voiceover, ClickAndReveal } from 'abbot-core';
import img1 from '../../assets/images/U1-T2-2-3a.svg';
import img2 from '../../assets/images/U1-T2-2-3b.svg';
import img3 from '../../assets/images/U1-T2-2-3c.svg';
import img4 from '../../assets/images/U1-T2-2-3d.svg';
import img5 from '../../assets/images/U1-T2-2-3e.svg';
import img6 from '../../assets/images/U1-T2-2-3f.svg';
import voAudio from '../../assets/vo/U1-T2-2-3.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      Food and drinks are required by law to have nutrition labels. These labels
      can tell you a lot about your food choices if you understand them.
    </p>
  )
};

const data = [
  {
    x: 28,
    y: 16,
    name: 'Servings Per Container',
    modal: {
      title: 'Servings Per Container',
      text:
        'It’s easy to think that a package of cookies or a soft drink in a can is one serving. Sometimes, it is actually two or more servings! The information provided on the Nutrition Label, though, refers to just one serving.  You may be eating double or more the amount of calories, fats, and other nutrients than you think you are!',
      image: img2,
      imageText: 'Servings Per Container'
    }
  },
  {
    x: 43,
    y: 28,
    name: 'Calories',
    modal: {
      title: 'Calories',
      text:
        'Calories refer to the energy available in the food or drink. Your body uses calories as fuel, and most kids between the ages of 6 and 12 need about 1200 to 2,000 calories a day. Young teenagers may need about 2,500 calories a day. The number of calories you need depends on how active you are. If you eat more calories than you use, it can lead to health issues.  You also don’t want to “bunch” your calories or eat them all at one point during the day, because your body will need enough “fuel” to get you through the day. So, it is best to spread them out!',
      image: img3,
      imageText: 'Calories'
    }
  },
  {
    x: 25,
    y: 46,
    name: 'Fats',
    modal: {
      title: 'Fats',
      text:
        'Fats are a very important part of a balanced diet, as they provide one of the best sources of energy for your body. Essential fatty acids, like plant oils and fish oils, are needed by the body to function. Not all fats are the same, though. Saturated fats become more solid at room temperature and may increase some risk factors for developing certain noncommunicable diseases. Trans Fats are found in many foods such as margarine, packaged bakery goods and snacks, and are particularly harmful. Eating foods high in trans fats can increase your “bad cholesterol” and is one of the risk factors associated with heart disease.',
      image: img4,
      imageText: 'Fats'
    }
  },
  {
    x: 30,
    y: 74,
    name: 'Sodium',
    modal: {
      title: 'Sodium',
      text:
        'Salt is a source of sodium. Although your body needs a certain amount of sodium in order to stay healthy, most people eat far too much sodium each day. A high level of sodium in your food choices can lead to high blood pressure and other health issues.',
      image: img5,
      imageText: 'Sodium'
    }
  },
  {
    x: 45,
    y: 87,
    name: 'Carbohydrates',
    modal: {
      title: 'Carbohydrates',
      text:
        'Along with healthy fats, carbohydrates are sources of energy for your body. Complex carbohydrates, like whole grain breads, are better for you than simple carbohydrates, like white bread. Your body takes longer to break down complex carbohydrates like those found in beans and whole grain breads. As a result, you may feel fuller and have more energy for longer.  When looking at a nutrition label, look for higher levels of fiber and lower levels of added sugars.',
      image: img6,
      imageText: 'Carbohydrates'
    }
  }
];

export default {
  title: 'Understanding Food Labels',
  path: '/learn/understanding-food-labels',
  content: (
    <Fragment>
      <Voiceover {...vo} />

      <Intro
        title="Understanding Food Labels"
        lead="Nutrition labels can tell you a lot about your food choices if you understand them."
        direction="Select each hotspot to learn more."
      />

      <ClickAndReveal
        data={data}
        backgroundImage={img1}
        backgroundImageText="Food Label"
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/learn/UnderstandingFoodLabels.js